import styled from "styled-components";
import { borderRadius } from "../../utils/border-radius.es.js";
const ALIGN_X_VALUES = {
  center: "center",
  left: "start",
  right: "end",
  stretch: "stretch"
};
const BORDER_RADIUS_SIZE_VALUES = {
  none: 0,
  small: 2,
  large: 4
};
const PADDING_SIZES = {
  none: 0,
  xsmall: 4,
  small: 8,
  medium: 16,
  large: 24,
  xlarge: 32
};
const EXTENDED_PADDING_VALUE = 1.5;
const OVERFLOW_VALUES = {
  scroll: "auto",
  visible: "visible"
};
const SIZING_VALUES = {
  auto: "auto",
  "fill-container": "100%",
  "fit-content": "fit-content"
};
const ContentImpl = styled("div")(
  ({ theme }) => ({
    border: `0 solid ${theme.borderColor}`,
    display: "flex",
    flexDirection: "column"
  }),
  ({ $alignX }) => ({
    alignItems: ALIGN_X_VALUES[$alignX]
  }),
  ({ $backgroundColor }) => ({ backgroundColor: $backgroundColor }),
  ({ $borderBottom }) => ({ borderBottomWidth: $borderBottom ? 1 : 0 }),
  ({ $borderColor }) => ({ borderColor: $borderColor }),
  ({ $borderLeft }) => ({ borderLeftWidth: $borderLeft ? 1 : 0 }),
  ({ $borderRight }) => ({ borderRightWidth: $borderRight ? 1 : 0 }),
  ({ $borderTop }) => ({ borderTopWidth: $borderTop ? 1 : 0 }),
  ({ $borderRadiusPlacement, $borderRadiusSize }) => borderRadius(
    $borderRadiusPlacement,
    BORDER_RADIUS_SIZE_VALUES[$borderRadiusSize]
  ),
  ({ $borderBottomRightRadiusSize }) => ({
    borderBottomRightRadius: BORDER_RADIUS_SIZE_VALUES[$borderBottomRightRadiusSize]
  }),
  ({ $borderTopLeftRadiusSize }) => ({
    borderTopLeftRadius: BORDER_RADIUS_SIZE_VALUES[$borderTopLeftRadiusSize]
  }),
  ({ $borderTopRightRadiusSize }) => ({
    borderTopRightRadius: BORDER_RADIUS_SIZE_VALUES[$borderTopRightRadiusSize]
  }),
  ({ $height }) => ({ height: $height }),
  ({ $maxHeight }) => ({ maxHeight: $maxHeight }),
  ({ $maxWidth }) => ({ maxWidth: $maxWidth }),
  ({ $minHeight }) => ({ minHeight: $minHeight }),
  ({ $minWidth }) => ({ minWidth: $minWidth }),
  ({ $overflow }) => ({ overflow: OVERFLOW_VALUES[$overflow] }),
  ({ $padding, $paddingMode }) => ({
    padding: PADDING_SIZES[$padding],
    paddingBottom: $paddingMode === "extended" ? EXTENDED_PADDING_VALUE * PADDING_SIZES[$padding] : void 0
  }),
  ({ $shadow }) => ({
    boxShadow: $shadow ? "0px 4px 12px rgba(0, 0, 0, 0.2)" : void 0
  }),
  ({ $sizing }) => ({
    width: SIZING_VALUES[$sizing]
  }),
  ({ $textAlign }) => ({ textAlign: $textAlign }),
  ({ $textColor }) => ({ color: $textColor }),
  ({ $width }) => ({ width: $width })
);
export {
  ContentImpl
};
